/**
 * @file 组件初始化入口
 */

import TBackTop from './back-top.vue'

TBackTop.install = Vue => {
  Vue.component(TBackTop.name, TBackTop)
}

export {
  TBackTop
}



// WEBPACK FOOTER //
// ./src/module/back-top/index.js